import { render, staticRenderFns } from "./PermissionListPage.vue?vue&type=template&id=0793e223&"
import script from "./PermissionListPage.vue?vue&type=script&lang=ts&"
export * from "./PermissionListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports